var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlacering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 51,
    viewBox: "0 0 61 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(-245 -422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M0,0H18V36H0Z",
    transform: "translate(245 437)",
    fill: "#e29c00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 19,
    height: 51,
    transform: "translate(266 422)",
    fill: "#e29c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M0,0H18V25H0Z",
    transform: "translate(288 448)",
    fill: "#e29c00"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(275 436)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "Lato-Black, Lato",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2.32,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(253 448)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "Lato-Black, Lato",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2.32,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(296 459)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "Lato-Black, Lato",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2.32,
    y: 0
  }, "3")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacering);
export default __webpack_public_path__ + "static/media/placering.3073168f5a5d1bd28ff7c06852061e18.svg";
export { ForwardRef as ReactComponent };